import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 't-llevo-overlay-button',
  standalone: true,
  imports: [CommonModule, OverlayModule, MatButtonModule, MatIconModule],
  templateUrl: './overlay-button.component.html',
  styleUrl: './overlay-button.component.css',
})
export class OverlayButtonComponent {
  @Input({required: true}) value!: string
  @Input() disableClose = false
  @Input() disabled = false
  private _isOpen = false

  open() {
    this._isOpen = true;
  }

  close() {
    if(!this.disableClose){
      this._isOpen = false;
    }
  }

  get isOpen(){
    return this._isOpen
  }
}
